(function () {
  'use strict';

  function clampQuantity(input) {
    var value = parseInt(input.value, 10);
    input.value = Number.isFinite(value) && value > 0 ? value : 1;
  }

  async function submitNativeFallback(form, submitter, status) {
    if (form.dataset.cvS4FallbackSubmitting === 'true') return;

    form.dataset.cvS4FallbackSubmitting = 'true';
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }
    if (status) status.textContent = 'Adding selected quantity to cart…';

    try {
      var routes = window.Theme && window.Theme.routes ? window.Theme.routes : {};
      var response = await fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      var payload = await response.json();

      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'Unable to add this item to the cart.');
      }

      window.location.assign(routes.cart_url || '/cart');
    } catch (error) {
      var message = error instanceof Error ? error.message : 'Unable to add this item to the cart.';
      if (status) status.textContent = message;
      form.removeAttribute('data-cv-s4-fallback-submitting');
      if (submitter) {
        submitter.removeAttribute('aria-busy');
        submitter.disabled = false;
      }
    }
  }

  function setupGallery(root) {
    var openButton = root.querySelector('[data-cv-s4-gallery-open]');
    var dialog = root.querySelector('[data-cv-s4-gallery]');
    if (!openButton || !dialog || typeof dialog.showModal !== 'function') return;

    var closeButton = dialog.querySelector('[data-cv-s4-gallery-close]');
    var previousButton = dialog.querySelector('[data-cv-s4-gallery-prev]');
    var nextButton = dialog.querySelector('[data-cv-s4-gallery-next]');
    var count = dialog.querySelector('[data-cv-s4-gallery-count]');
    var slides = Array.prototype.slice.call(dialog.querySelectorAll('[data-cv-s4-gallery-slide]'));
    var index = 0;

    function render() {
      slides.forEach(function (slide, slideIndex) { slide.hidden = slideIndex !== index; });
      if (count) count.textContent = (index + 1) + ' of ' + slides.length;
    }

    function move(step) {
      if (!slides.length) return;
      index = (index + step + slides.length) % slides.length;
      render();
    }

    function closeGallery() {
      if (dialog.open) dialog.close();
    }

    function openGallery() {
      index = 0;
      render();
      dialog.showModal();
      if (closeButton) closeButton.focus();
    }

    openButton.addEventListener('click', openGallery);
    openButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openGallery();
      }
    });
    if (closeButton) closeButton.addEventListener('click', closeGallery);
    if (previousButton) previousButton.addEventListener('click', function () { move(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { move(1); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeGallery(); });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeGallery();
    });
    dialog.addEventListener('close', function () { openButton.focus(); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeGallery();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
      if (event.key === 'Tab') {
        var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        var current = focusable.indexOf(document.activeElement);
        var next = event.shiftKey ? (current <= 0 ? focusable.length - 1 : current - 1) : (current >= focusable.length - 1 ? 0 : current + 1);
        event.preventDefault();
        focusable[next].focus();
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.cvS4Ready === 'true') return;
    root.dataset.cvS4Ready = 'true';

    var formId = root.dataset.productFormId;
    var form = formId ? document.getElementById(formId) : root.querySelector('form[action*="/cart/add"]');
    var quantity = root.querySelector('[data-cv-s4-quantity]');
    var minus = root.querySelector('[data-cv-s4-quantity-minus]');
    var plus = root.querySelector('[data-cv-s4-quantity-plus]');
    var status = root.querySelector('[data-cv-s4-form-status]');
    var addButton = root.querySelector('[data-cv-s4-add]');

    if (quantity) {
      quantity.addEventListener('change', function () { clampQuantity(quantity); });
      quantity.addEventListener('blur', function () { clampQuantity(quantity); });
      quantity.addEventListener('input', function () {
        if (quantity.value !== '' && parseInt(quantity.value, 10) < 1) clampQuantity(quantity);
      });
      if (minus) minus.addEventListener('click', function () {
        clampQuantity(quantity);
        quantity.value = Math.max(1, parseInt(quantity.value, 10) - 1);
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', function () {
        clampQuantity(quantity);
        quantity.value = parseInt(quantity.value, 10) + 1;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (form && addButton) {
      addButton.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        event.stopPropagation();
        submitNativeFallback(form, addButton, status);
      });
    }

    if (form && status) {
      form.addEventListener('submit', function () {
        status.textContent = 'Adding selected quantity to cart…';
      });
    }

    setupGallery(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cv-s4-root]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('click', function (event) {
    var faqButton = event.target.closest && event.target.closest('[data-cv-s4-faq-button]');
    if (faqButton) {
      var answerId = faqButton.getAttribute('aria-controls');
      var answer = answerId && document.getElementById(answerId);
      if (answer) {
        var expanded = faqButton.getAttribute('aria-expanded') === 'true';
        faqButton.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        answer.hidden = expanded;
      }
      return;
    }
    var proxy = event.target.closest && event.target.closest('[data-cv-s4-add-proxy]');
    if (!proxy) return;
    var root = document.querySelector('[data-cv-s4-root]');
    var form = root && document.getElementById(root.dataset.productFormId);
    if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
  });
}());

